
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"37","viewBox":"0 0 36 37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 3.5c-8.284 0-15 6.716-15 15 0 8.285 6.716 15 15 15 8.285 0 15-6.715 15-15 0-8.284-6.715-15-15-15zm-3 20.25v-10.5a.75.75 0 011.2-.6l7 5.25c.401.3.401.9 0 1.2l-7 5.25a.75.75 0 01-1.2-.6z","fill":"#fff"}})])
          )
        }
      }
    